import {Section} from '@primer/react-brand/esm'
import {CopilotLogoSuite} from '../../_components/CopilotLogoSuite/CopilotLogoSuite'

import styles from './HeroSection.module.css'

import type {HeroSectionContent} from '../../content'

import {HeroIntro} from './HeroIntro'
import {HeroCarousel} from './HeroCarousel'

type Props = {
  contentfulContent: HeroSectionContent
}

export function HeroSection(props: Props) {
  const {contentfulContent} = props

  const sectionId = contentfulContent.section.fields.htmlId

  const intro = contentfulContent.intro
  const carousel = contentfulContent.carousel
  const logoSuite = contentfulContent.logoSuite
  const logoSuiteHeading = logoSuite?.fields.heading

  return (
    <Section id={sectionId} className={styles.HeroSection}>
      {intro ? <HeroIntro contentfulContent={intro} /> : null}
      {carousel ? <HeroCarousel items={carousel} heading={intro?.fields.heading} /> : null}

      <Section
        as="div"
        paddingBlockStart="condensed"
        paddingBlockEnd="condensed"
        variant="gridline"
        data-hide-gridline="top"
        data-padding-inline="0"
      >
        {logoSuite ? <CopilotLogoSuite location="hero" heading={logoSuiteHeading} /> : null}
      </Section>
    </Section>
  )
}
